<nb-form-field>
  <input
    nbInput
    fullWidth
    type="number"
    step="0.01"
    min="0"
    [disabled]="isDisabled"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
  >
  <span nbSuffix class="suffix">m²</span>
</nb-form-field>
